<template>
	<div class="item5">
		<img class="logoico" src="../assets/images/logo.png" />
		<back></back>
		<div class="item5box">
			<div class="title">
				<div>养生篇</div>
			</div>

			<div class="context">
				<div class="bagbag">
					
				</div>
				<span class="videotitle">养生十三法</span>
				<div class="contextright">
					<div class="btnitem" v-for="item in videolist">
						<a href="javascript:void(0);" @click="showvideo(item.id)">
							<div>
								<img v-if="item.imageAtt!=null" :src="$api.imgUrl + '' + item.imageAtt.fastFileId" />
							</div>
							<div>
								<span>{{item.title}}</span>
							</div>
						</a>
					</div>
				</div>
			</div>
		</div>
		<div class="dailog" v-if="videoisshow">
			<div class="dailogbox" v-if="showlist!=null">
				<a class="close" @click="videoisshow=false" href="javascript:void(0);"><img class="closeimg"
						src="../assets/images/tcclose.png" /></a>
				<div class="videotitle2">
					<img src="../assets/images/videobentitle2.png" />
					<span>{{showlist.title}}</span>
				</div>
				<div class="videobox">
					<div class="video">
						<video autoplay loop controlslist="nodownload" controls :src="$api.imgUrl +'' + showlist.videoAtt.fastFileId"
							style="width= 100%; height=100%;object-fit: fill;"></video>
					</div>
					<div class="videotext">
						<img src="../assets/images/videotextbag.png" />
						<div v-html="showlist.content">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import back from '../components/backhome/back.vue'
	import axios from 'axios'
	export default {
		components: {
			back
		},
		data() {
			return {
				token: this.$store.state.token,
				userid: this.$store.state.userid,
				videoisshow: false,
				videotitle: '',
				videolist: [],
				showlist: null
			}
		},
		created() {
			this.getlist()
		},
		methods: {
			showvideo(id){
				this.videoisshow = true
				this.videolist.map((item)=>{
					if(item.id===id){
						this.showlist = item
					}
				})
				// axios({
				// 	url: this.$api.commonUrl + 'posts/'+id,
				// 	type: 'GET',
				// 	headers: {
				// 		"Authorization": "Bearer " + this.token
				// 	}
				// }).then(res => {
				// 	if (res.data.code == 200) {
				// 		this.showlist = res.data.data
				// 	}
				// }).catch(err => {
				// 	console.log(err)
				// })
			},
			getlist() {
				axios({
					url: this.$api.commonUrl + 'posts/category/12',
					type: 'GET',
					headers: {
						"Authorization": "Bearer " + this.token
					}
				}).then(res => {
					if (res.data.code == 200) {
						this.videolist = res.data.data
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped>
	.bagbag{
		background: url(../assets/images/videoscrollbag.png) no-repeat;
		background-size: 100% 110%;
		background-position: center;
		position: absolute;
		top: -22%;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: -1;
	}
	.item5 .videotext {
		width: calc(100% - 10px);
		height: 12rem;
		background-size: 100% 100%;
		line-height: 2rem;
		overflow-y: auto;
		padding: 5px;
		position: relative;
		margin-top: -10px;
	}

	.item5 .videotext div {
		width: calc(100% - 4rem);
		height: 9rem;
		line-height: 1.5rem;
		overflow-y: auto;
		position: absolute;
		top: 1rem;
		left: 1rem;
		right: 1rem;
		bottom: 1rem;
		padding: 1rem;
		font-size: 1.1rem;
	}

	.item5 .videotext img {
		width: calc(100% - 10px);
		height: calc(100% - 10px);
		position: absolute;
	}

	.item5 .videobox {
		background: #FFFFFF;
		margin-top: 1rem;
	}

	.item5 .dailog {
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background: rgba(0, 0, 0, 0.8);
		z-index: 999;
	}

	.item5 .videotitle2 {
		text-align: center;
		position: relative;
		height: 3rem;
		line-height: 3rem;
	}

	.item5 .videotitle2 img {
		height: 3rem;
		display: inline-block;
	}

	.item5 .videotitle2 span {
		position: absolute;
		margin: auto;
		left: 0;
		right: 0;
		bottom: 0;
		color: #FFFFFF;
		font-size: 1.3rem;
		top: 0;
		font-weight: bold;
	}

	.item5 {
		background: url(../assets/images/item5bag.jpg) no-repeat;
		background-size: 120% auto;
		background-position: left center;
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 1;
	}

	.item5 .item5box {
		position: absolute;
		z-index: 3;
		left: 1rem;
		top: 8rem;
		right: 1rem;
		bottom: 1rem;
		text-align: center;
	}

	.item5 .logoico {
		position: absolute;
		top: 3rem;
		left: 3rem;
		width: 18rem;
	}

	.item5 .title {
		height: 6rem;
		text-align: center;
	}

	.item5 .title div {
		line-height: 6rem;
		width: calc(6rem * 6.39);
		height: 6rem;
		margin: 0px auto;
		background: url(../assets/images/itemtitlebag.png) no-repeat;
		background-size: 100%;
		font-family: 'STXingkai';
		font-size: 3rem;
		color: #FFFFFF;
	}

	.item5 .context {
		width: 80rem;
		height: 52rem;
		margin: 0px auto;
		margin-top: 2rem;
		position: relative;
	}

	.item5 .contextright {
		width: calc(100% - 3rem);
		height: 52rem;
		display: flex;
		flex-wrap: wrap;
		float: left;
		overflow-y: auto;
	}

	.item5 .videotitle {
		width: 3rem;
		height: calc(3rem * 3.458);
		float: left;
		background: url(../assets/images/titlebagvideo.png) no-repeat;
		background-size: 100%;
		color: #FFFFFF;
		writing-mode: vertical-lr;
		/*从左向右 从右向左是 writing-mode: vertical-rl;*/
		writing-mode: tb-lr;
		/*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/
		text-align: center;
		justify-content: center;
		display: flex;
		-webkit-display: flex;
		flex-direction: column;
		font-size: 1.1rem;
		font-weight: bold;
	}

	.item5 .context .btnitem {
		width: 25%;
		height: 15rem;
		text-align: center;
		padding-top: 1rem;
		padding-bottom: 2rem;
		position: relative;
	}

	.item5 .context .btnitem img {
		width: 70%;
		height: auto;
		display: inline-block;
	}

	.item5 .context .btnitem span {
		background: url(../assets/images/videobtnbag.png) no-repeat;
		background-size: 100%;
		display: inline-block;
		width: calc(2.2rem * 4.17);
		height: 2.2rem;
		line-height: 2.2rem;
		font-size: 1rem;
		color: #36444b;
		font-weight: bold;
	}

	.item5 .videotext div::-webkit-scrollbar {
		width: 6px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 1px;
	}

	/*滚动条里面小方块*/
	.item5 .videotext div::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(54, 68, 75, 1);
		background: rgba(54, 68, 75, 1);
	}

	/*滚动条里面轨道*/
	.item5 .videotext div::-webkit-scrollbar-track {
		box-shadow: inset 0 0 5px rgba(54, 68, 75, 0.3);
		border-radius: 10px;
		background: rgba(54, 68, 75, 0.3);
	}

	.item5 .contextright::-webkit-scrollbar {
		width: 6px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 1px;
	}

	/*滚动条里面小方块*/
	.item5 .contextright::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(54, 68, 75, 1);
		background: rgba(54, 68, 75, 1);
	}

	/*滚动条里面轨道*/
	.item5 .contextright::-webkit-scrollbar-track {
		box-shadow: inset 0 0 5px rgba(54, 68, 75, 0.3);
		border-radius: 10px;
		background: rgba(54, 68, 75, 0.3);
	}

	.item5 .dailogbox {
		width: 55%;
		height: 80%;
		position: absolute;
		margin: auto;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
	}

	.item5 .close {
		position: absolute;
		right: -4rem;
		top: -2rem;
		display: block;
		width: 4rem;
		z-index: 999;
		height: 4rem;
	}

	.item5 .closeimg {
		display: block;
		width: 4rem;
		height: 4rem;
	}

	.item5 .video {
		width: 100%;
		height: auto;
	}

	.item5 .video video {
		width: calc(100% - 12px);
		height: auto;
		margin: 5px;
		border: 1px solid #9e714d;
	}
	.item5 .context .btnitem a{
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
	}
</style>
